

import store from '../store'
import Request from './request'
import i18n from '@/i18n';
// Self-made Snackbar
import snackbar from '@/plugins/snackbar';

async function fetch(data){
    return Request("get","api/receipt",data)
}

async function fetchOne(id,data){
    return Request("get","api/receipt/" + id,data)
}

// 对账单详情下载
async function download(data){
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/receipt/detail-export?" , data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.excelDownload"));
    }
    window.location.href = response.data.report_url;
    store.dispatch("fullscreenLoadingStop");
    return response;
}

// 导出excel
async function exportExcel(data){
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/receipt/export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    window.location.href = response.data.report_url;
    store.dispatch("fullscreenLoadingStop");
    return response;
}

// 批量导出
async function exportBatchExcel(data){
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/receipt/batch-detail-export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    window.location.href = response.data.report_url;
    store.dispatch("fullscreenLoadingStop");
    return response;
}

export default {
    fetch,
    fetchOne,
    download,
    exportExcel,
    exportBatchExcel,
}